/**
 *
 * Subscribe
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import _classNames from 'classnames';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { toast } from 'react-toastify';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import Typography from '@material-ui/core/Typography';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _some from 'lodash/some';
import { submitSubscription } from 'containers/Auth/actions';
import {
  makeSelectProfile,
  makeSelectSubscriptionResult,
  makeSelectSubscriptionProcessing,
} from 'containers/Auth/selectors';
import {
  makeSelectAllowSignIn,
  makeSelectHomeHeaders,
  makeSelectClientDetails,
  makeSelectSiteCopy,
} from 'containers/Main/selectors';
import AppContainer from 'components/AppContainer';
import EmailIcon from 'components/SubscriptionOptions/images/modal-email.svg';
import { setLocalData } from 'utils/localDataStore';
import { emailRegex } from 'utils/stringUtils';

const styles = theme => ({
  container: {
    width: '100%',
    height: 162,
    background: theme.palette.primary.main,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#fff',
    [theme.breakpoints.down('sm')]: {
      height: 250,
    },
    [theme.breakpoints.down('xs')]: {
      height: 350,
    },
  },
  inputWrapper: {
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
  },
  inputIcon: {
    position: 'absolute',
    top: 36,
    left: 20,
    [theme.breakpoints.down('sm')]: {
      top: 32,
    },
    [theme.breakpoints.down('xs')]: {
      top: 27,
    },
  },
  input: {
    textIndent: 30,
    marginTop: '2%',
    marginBottom: '2%',
    minWidth: 357,
    background: '#ffffff',
    color: '#000',
    height: 48,
    padding: '0 24px',
    border: '1px solid #E9ECED',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      minWidth: 0,
    },
  },
  inputError: {
    border: '1px solid #f44336',
  },
  submit: {
    border: '1px solid #fff',
    ...theme.typography.button,
    width: 163,
    height: 48,
    marginLeft: 12,
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      margin: 4,
    },
  },
  title: {
    marginBottom: 5,
  },
});

class Subscribe extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      error: false,
    };
  }

  componentDidUpdate(prevProps) {
    const { subscriptionResult } = this.props;
    if (
      prevProps.subscriptionResult !== subscriptionResult &&
      !_isEmpty(subscriptionResult) &&
      subscriptionResult.subscribeSection
    ) {
      if (!subscriptionResult.error) {
        toast('Thanks for subscribing! We will be in touch.', {
          type: 'success',
        });
        // auto close subscription modal
        setLocalData('isSubscribed', 'true', {
          expires: 365,
        });
      } else if (subscriptionResult.exists) {
        toast(subscriptionResult.errorMessage, {
          type: 'warning',
        });
      } else {
        toast(subscriptionResult.errorMessage, {
          type: 'error',
        });
      }
    }
  }

  handleEmailChange = e => {
    this.setState({ email: e.target.value, error: false });
  };

  handleSubmit = () => {
    const { email } = this.state;
    const { clientDetails, profile, siteCopy } = this.props;

    const workEmailDomains = _get(
      clientDetails,
      'context.requiredEmailDomains',
      [],
    );
    const personalEmailModalSiteCopy = (siteCopy || []).find(
      item => item.slug === 'personal-email-modal',
    );

    if (!emailRegex.test(String(email).toLowerCase())) {
      toast('Insert a valid email address.', {
        type: 'error',
      });
      this.setState({ error: true });
    } else if (
      !_some(workEmailDomains, domain =>
        String(email)
          .toLowerCase()
          .includes(domain),
      ) &&
      email === profile.email
    ) {
      toast(_get(personalEmailModalSiteCopy, 'pageCopy.errorMessage', ''), {
        type: 'error',
      });
      this.setState({ error: true });
    } else {
      this.props.submitSubscription({
        email,
        subscription: ['resources'],
        subscribeSection: true,
      });
    }
  };

  render() {
    const { allowSignIn, classes, homeHeaders } = this.props;
    const { email, error } = this.state;

    if (!allowSignIn) return null;

    const SubscribeBtn = (
      <Button
        color="primary"
        variant="contained"
        className={classes.submit}
        onClick={this.handleSubmit}
      >
        {_get(homeHeaders, 'pageCopy.subscriptionButtonLabel', '')}
      </Button>
    );

    return (
      <div className={classes.container}>
        <AppContainer>
          <Grid item xs={12}>
            <Grid container direction="row" spacing={1}>
              <Grid item xs={12} sm={12} md={6}>
                <Typography variant="h5" className={classes.title}>
                  {_get(homeHeaders, 'pageCopy.subscriptionHeader', '')}
                </Typography>
                <Typography variant="body2">
                  {_get(homeHeaders, 'pageCopy.subscriptionBody', '')}
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                className={classes.inputWrapper}
              >
                <img
                  src={EmailIcon}
                  alt="Email"
                  className={classes.inputIcon}
                />
                <input
                  type="email"
                  autoComplete="off"
                  value={email}
                  aria-label="email address"
                  placeholder={_get(
                    homeHeaders,
                    'pageCopy.subscriptionPlaceholder',
                    '',
                  )}
                  onChange={this.handleEmailChange}
                  className={_classNames({
                    [classes.input]: true,
                    [classes.inputError]: error,
                  })}
                />
                <Hidden xsDown>{SubscribeBtn}</Hidden>
              </Grid>
              <Hidden smUp>{SubscribeBtn}</Hidden>
            </Grid>
          </Grid>
        </AppContainer>
      </div>
    );
  }
}

Subscribe.propTypes = {
  allowSignIn: PropTypes.bool,
  classes: PropTypes.object,
  homeHeaders: PropTypes.object,
  submitSubscription: PropTypes.func,
  subscriptionResult: PropTypes.object,
};

const mapStateToProps = createStructuredSelector({
  allowSignIn: makeSelectAllowSignIn(),
  clientDetails: makeSelectClientDetails(),
  homeHeaders: makeSelectHomeHeaders(),
  siteCopy: makeSelectSiteCopy(),
  subscriptionResult: makeSelectSubscriptionResult(),
  processing: makeSelectSubscriptionProcessing(),
  profile: makeSelectProfile(),
});

function mapDispatchToProps(dispatch) {
  return {
    submitSubscription: payload => dispatch(submitSubscription(payload)),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withConnect,
  withRouter,
  withStyles(styles),
)(Subscribe);
